import { Link } from 'react-router-dom';
import type { GameManifest } from '@adgf/shared';

interface GameListProps {
  games: GameManifest[];
}

export default function GameList({ games }: GameListProps) {
  if (games.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--color-text-muted)' }}>
        <p>No games available yet.</p>
        <p style={{ fontSize: '0.85rem', marginTop: 8 }}>
          Games will appear here once they are published through the pipeline.
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: 20,
      }}
    >
      {games.map((game) => (
        <Link
          key={game.id}
          to={`/game/${game.slug}`}
          style={{
            background: 'var(--color-bg-secondary)',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius)',
            padding: 20,
            textDecoration: 'none',
            color: 'var(--color-text)',
            transition: 'transform 0.2s, border-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.borderColor = 'var(--color-primary)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.borderColor = 'var(--color-border)';
          }}
        >
          <h3 style={{ fontSize: '1.1rem', marginBottom: 8 }}>{game.title}</h3>
          <p
            style={{
              fontSize: '0.85rem',
              color: 'var(--color-text-muted)',
              marginBottom: 12,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {game.description || 'No description'}
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <span
              style={{
                fontSize: '0.75rem',
                padding: '2px 8px',
                borderRadius: 4,
                background: 'var(--color-accent)',
                textTransform: 'capitalize',
              }}
            >
              {game.runtime}
            </span>
            <span
              style={{
                fontSize: '0.75rem',
                padding: '2px 8px',
                borderRadius: 4,
                background: 'var(--color-accent)',
                textTransform: 'capitalize',
              }}
            >
              {game.difficulty}
            </span>
            <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>
              v{game.version}
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}
